import Dashes = require("./linedash");

export =
    [
        {
            "stroke": {
                "color": "orange",
                "width": 2,
                "lineDash": Dashes.longdashdotdot
            }

        }
    ];